export default __webpack_public_path__ + "static/favicon-167-touch-892295c593433af7fc0950eaa958a95c.png";